import(/* webpackMode: "eager", webpackExports: ["HoroscopeSidebarAds","HoroscopeClientTools"] */ "/app/app/(horoscope)/horoscope/components/HoroscopeClientSlots.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/(horoscope)/horoscope/components/HoroscopeMenu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
